import { ProviderCode } from "./enums";

export interface LocalPaymentData {
  id?: string;
  methods: string[];
  debitBrands: string[];
  creditBrands: string[];
}

const LOCAL_PAYMENT_CODE = ProviderCode.LocalPayment;

function stringArray(value: unknown): string[] {
  return Array.isArray(value) ? value.map(String) : [];
}

export function normalizeProvidersList(payload: unknown): unknown[] {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];
  const { data, providers } = payload as Record<string, unknown>;
  if (Array.isArray(data)) return data;
  if (Array.isArray(providers)) return providers;
  return [];
}

export function extractLocalPaymentData(
  provider: unknown,
): LocalPaymentData | null {
  if (!provider || typeof provider !== "object") return null;
  const p = provider as Record<string, unknown>;
  if (String(p.code ?? "") !== LOCAL_PAYMENT_CODE) return null;

  const acquirer =
    p.acquirer && typeof p.acquirer === "object"
      ? (p.acquirer as Record<string, unknown>)
      : undefined;

  return {
    id: p.id != null ? String(p.id) : undefined,
    methods: stringArray(p.methods),
    creditBrands: stringArray(acquirer?.creditBrands),
    debitBrands: stringArray(acquirer?.debitBrands),
  };
}
